import LgPdpComponent, { getServerSideProps as getServerSidePropsPdp } from '.';

export async function getServerSideProps(ctx) {
  return getServerSidePropsPdp({ ...ctx, isProductSlugPath: true })
}

export default LgPdpComponent;
